/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var EduHatIcon20Solid = forwardRef('EduHatIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.606 2.826a4.118 4.118 0 0 0-3.212 0L.863 6.069c-1.156.497-1.148 1.933.01 2.422l7.543 3.193a4.12 4.12 0 0 0 3.168 0l6.166-2.61v3.127a1.5 1.5 0 1 0 1.5 0V8.434c1.034-.536 1-1.886-.113-2.365l-7.531-3.243Z" }),
        React.createElement("path", { d: "M4 11.315v2.796c0 1.253.86 2.18 1.935 2.754 1.086.578 2.527.885 4.065.885 1.538 0 2.98-.307 4.065-.885C15.141 16.29 16 15.365 16 14.11v-2.796l-4.416 1.869a4.12 4.12 0 0 1-3.168 0L4 11.314Z" })));
});
